export const DUMMY_AUDIT_TRAIL = [
  {
    companyName: 'mca',
    date: new Date('2023-02-06'),
    userName: 'daniel levy',
    system: 'tgs',
    switches: {
      'bet-east': ['01', '02', '03', '04', '05'],
      'bet-west': ['01', '02', '03', '04', '05'],
      'south-coast': ['01', '02', '03', '04', '05'],
    },
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-01',
      'bet-east-02',
      'bet-east-03',
      'bet-east-04',
      'bet-east-05',
      'bet-west-01',
      'bet-west-02',
      'bet-west-03',
      'bet-west-04',
      'bet-west-05',
      'south-coast-01',
      'south-coast-02',
      'south-coast-03',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 300°C ',
      fanOnly: '',
      snowSensor: '',
      heatingSchedule: '',
      windFactor: '',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-02-07'),
    userName: 'daniel levy',
    system: 'tes',
    switches: {
      'bet-east': ['01', '02', '03', '04', '05'],
      'bet-west': ['01', '02', '03', '04', '05'],
      'south-coast': ['01', '02', '03', '04', '05'],
    },
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-01',
      'bet-east-02',
      'bet-west-01',
      'bet-west-02',
      'bet-west-03',
      'bet-west-04',
      'south-coast-01',
      'south-coast-02',
      'south-coast-03',
    ],
    parameters: {
      instantHeat: 'active 300°C',
      optionalConstantTemp: 'ready 150°C',
      snowSensor: 'ready 350°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 250°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-02-10'),
    userName: 'daniel levy',
    system: 'ess',
    locations: ['bet-east', 'bet-west', 'south-coast'],
    switches: {
      'bet-east': ['01', '03', '04', '05'],
      'bet-west': ['04', '05'],
      'south-coast': ['01', '02', '04', '05'],
    },
    machines: [
      'bet-east-01',
      'bet-east-03',
      'bet-east-04',
      'bet-east-05',
      'bet-west-04',
      'bet-west-05',
      'south-coast-01',
      'south-coast-02',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 300°C',
      optionalConstantTemp: 'ready 150°C',
      snowSensor: 'ready 350°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 250°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-02-02'),
    userName: 'daniel levy',
    system: 'ess',
    locations: ['bet-east', 'bet-west', 'south-coast'],
    switches: {
      'bet-east': ['05'],
      'bet-west': ['01', '02', '05'],
      'south-coast': ['04', '05'],
    },
    machines: [
      'bet-east-05',
      'bet-west-01',
      'bet-west-02',
      'bet-west-05',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 375°C',
      optionalConstantTemp: 'ready 100°C',
      snowSensor: 'ready 450°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 350°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-01-06'),
    userName: 'daniel levy',
    system: 'ess',
    switches: {
      'bet-east': ['05'],
      'bet-west': ['01', '02', '05'],
      'south-coast': ['04', '05'],
    },
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-05',
      'bet-west-01',
      'bet-west-02',
      'bet-west-05',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 375°C',
      optionalConstantTemp: 'ready 100°C',
      snowSensor: 'ready 450°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 350°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-01-06'),
    userName: 'daniel levy',
    system: 'ess',
    locations: ['bet-east', 'bet-west', 'south-coast'],
    switches: {
      'bet-east': ['05'],
      'bet-west': ['01', '02'],
      'south-coast': ['04', '05'],
    },
    machines: [
      'bet-east-05',
      'bet-west-01',
      'bet-west-02',
      'bet-west-05',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 375°C',
      optionalConstantTemp: 'ready 100°C',
      snowSensor: 'ready 450°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 350°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-01-20'),
    userName: 'daniel levy',
    system: 'ess',
    switches: {
      'bet-east': ['05'],
      'bet-west': ['01', '05'],
      'south-coast': ['04', '05'],
    },
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-05',
      'bet-west-01',
      'bet-west-02',
      'bet-west-05',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 375°C',
      optionalConstantTemp: 'ready 100°C',
      snowSensor: 'ready 450°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 350°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-01-15'),
    userName: 'lea angelvile',
    system: 'tgs',
    switches: {
      'bet-east': ['01', '02', '03', '04', '05'],
      'bet-west': ['01', '02', '03', '04', '05'],
      'south-coast': ['01', '02', '03', '04', '05'],
    },
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-01',
      'bet-east-02',
      'bet-east-03',
      'bet-east-04',
      'bet-east-05',
      'bet-west-01',
      'bet-west-02',
      'bet-west-03',
      'bet-west-04',
      'bet-west-05',
      'south-coast-01',
      'south-coast-02',
      'south-coast-03',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 300°C ',
      fanOnly: '',
      snowSensor: '',
      heatingSchedule: '',
      windFactor: '',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-01-04'),
    userName: 'lea angelvile',
    system: 'tes',
    locations: ['bet-east', 'bet-west', 'south-coast'],
    switches: {
      'bet-east': ['01', '02'],
      'bet-west': ['01', '02', '03', '04'],
      'south-coast': ['01', '02', '03'],
    },
    machines: [
      'bet-east-01',
      'bet-east-02',
      'bet-west-01',
      'bet-west-02',
      'bet-west-03',
      'bet-west-04',
      'south-coast-01',
      'south-coast-02',
      'south-coast-03',
    ],
    parameters: {
      instantHeat: 'active 300°C',
      optionalConstantTemp: 'ready 150°C',
      snowSensor: 'ready 350°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 250°C',
    },
  },

  {
    companyName: 'mca',
    date: new Date('2023-02-22'),
    userName: 'lea angelvile',
    system: 'ess',
    switches: {
      'bet-east': ['01', '03', '04', '05'],
      'bet-west': ['04', '05'],
      'south-coast': ['01', '02', '04', '05'],
    },
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-01',
      'bet-east-03',
      'bet-east-04',
      'bet-east-05',
      'bet-west-04',
      'bet-west-05',
      'south-coast-01',
      'south-coast-02',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 300°C',
      optionalConstantTemp: 'ready 150°C',
      snowSensor: 'ready 350°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 250°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-02-03'),
    userName: 'lea angelvile',
    system: 'ess',
    switches: {
      'bet-east': ['05'],
      'bet-west': ['01', '02', '05'],
      'south-coast': ['04', '05'],
    },
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-05',
      'bet-west-01',
      'bet-west-02',
      'bet-west-05',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 375°C',
      optionalConstantTemp: 'ready 100°C',
      snowSensor: 'ready 450°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 350°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2022-06-02'),
    userName: 'lea angelvile',
    system: 'ess',
    switches: {
      'bet-east': ['05'],
      'bet-west': ['01', '02', '05'],
      'south-coast': ['04', '05'],
    },
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-05',
      'bet-west-01',
      'bet-west-02',
      'bet-west-05',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 375°C',
      optionalConstantTemp: 'ready 100°C',
      snowSensor: 'ready 450°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 350°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2022-08-07'),
    userName: 'lea angelvile',
    system: 'ess',
    switches: {
      'bet-east': ['05'],
      'bet-west': ['01', '02'],
      'south-coast': ['04', '05'],
    },
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-05',
      'bet-west-01',
      'bet-west-02',
      'bet-west-05',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 375°C',
      optionalConstantTemp: 'ready 100°C',
      snowSensor: 'ready 450°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 350°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-02-26'),
    userName: 'lea angelvile',
    system: 'ess',
    switches: {
      'bet-east': ['05'],
      'bet-west': ['01', '02', '05'],
      'south-coast': ['04', '05'],
    },
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-05',
      'bet-west-01',
      'bet-west-02',
      'bet-west-05',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 375°C',
      optionalConstantTemp: 'ready 100°C',
      snowSensor: 'ready 450°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 350°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-02-15'),
    userName: 'carlos grande',
    system: 'tgs',
    switches: {
      'bet-east': ['01', '02', '03', '04', '05'],
      'bet-west': ['01', '02', '03', '04', '05'],
      'south-coast': ['01', '02', '03', '04', '05'],
    },
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-01',
      'bet-east-02',
      'bet-east-03',
      'bet-east-04',
      'bet-east-05',
      'bet-west-01',
      'bet-west-02',
      'bet-west-03',
      'bet-west-04',
      'bet-west-05',
      'south-coast-01',
      'south-coast-02',
      'south-coast-03',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 300°C ',
      fanOnly: '',
      snowSensor: '',
      heatingSchedule: '',
      windFactor: '',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-02-18'),
    userName: 'carlos grande',
    system: 'tes',
    switches: {
      'bet-east': ['01', '02'],
      'bet-west': ['01', '02', '03', '04'],
      'south-coast': ['01', '02', '03'],
    },
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-01',
      'bet-east-02',
      'bet-west-01',
      'bet-west-02',
      'bet-west-03',
      'bet-west-04',
      'south-coast-01',
      'south-coast-02',
      'south-coast-03',
    ],
    parameters: {
      instantHeat: 'active 300°C',
      optionalConstantTemp: 'ready 150°C',
      snowSensor: 'ready 350°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 250°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-02-19'),
    userName: 'carlos grande',
    system: 'ess',
    switches: {
      'bet-east': ['01', '03', '04', '05'],
      'bet-west': ['04', '05'],
      'south-coast': ['01', '02', '04', '05'],
    },
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-01',
      'bet-east-03',
      'bet-east-04',
      'bet-east-05',
      'bet-west-04',
      'bet-west-05',
      'south-coast-01',
      'south-coast-02',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 300°C',
      optionalConstantTemp: 'ready 150°C',
      snowSensor: 'ready 350°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 250°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-02-24'),
    userName: 'carlos grande',
    system: 'ess',
    switches: {
      'bet-east': ['05'],
      'bet-west': ['01', '02', '05'],
      'south-coast': ['04', '05'],
    },
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-05',
      'bet-west-01',
      'bet-west-02',
      'bet-west-05',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 375°C',
      optionalConstantTemp: 'ready 100°C',
      snowSensor: 'ready 450°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 350°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-01-20'),
    userName: 'carlos grande',
    system: 'ess',
    switches: {
      'bet-east': ['05'],
      'bet-west': ['01', '02', '05'],
      'south-coast': ['04', '05'],
    },
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-05',
      'bet-west-01',
      'bet-west-02',
      'bet-west-05',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 375°C',
      optionalConstantTemp: 'ready 100°C',
      snowSensor: 'ready 450°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 350°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-01-30'),
    userName: 'carlos grande',
    system: 'ess',
    switches: {
      'bet-east': ['05'],
      'bet-west': ['01', '02', '05'],
      'south-coast': ['04', '05'],
    },
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-05',
      'bet-west-01',
      'bet-west-02',
      'bet-west-05',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 375°C',
      optionalConstantTemp: 'ready 100°C',
      snowSensor: 'ready 450°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 350°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-02-01'),
    userName: 'carlos grande',
    system: 'ess',
    switches: {
      'bet-east': ['05'],
      'bet-west': ['01', '02', '05'],
      'south-coast': ['04', '05'],
    },
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-05',
      'bet-west-01',
      'bet-west-02',
      'bet-west-05',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 375°C',
      optionalConstantTemp: 'ready 100°C',
      snowSensor: 'ready 450°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 350°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-02-08'),
    userName: 'carol smith',
    system: 'tgs',
    switches: {
      'bet-east': ['01', '02', '03', '04', '05'],
      'bet-west': ['01', '02', '03', '04', '05'],
      'south-coast': ['01', '02', '03', '04', '05'],
    },
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-01',
      'bet-east-02',
      'bet-east-03',
      'bet-east-04',
      'bet-east-05',
      'bet-west-01',
      'bet-west-02',
      'bet-west-03',
      'bet-west-04',
      'bet-west-05',
      'south-coast-01',
      'south-coast-02',
      'south-coast-03',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 300°C ',
      fanOnly: '',
      snowSensor: '',
      heatingSchedule: '',
      windFactor: '',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-02-09'),
    userName: 'carol smith',
    system: 'tes',
    switches: {
      'bet-east': ['01', '02'],
      'bet-west': ['01', '02', '03'],
      'south-coast': ['01', '02', '03'],
    },
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-01',
      'bet-east-02',
      'bet-west-01',
      'bet-west-02',
      'bet-west-03',
      'bet-west-04',
      'south-coast-01',
      'south-coast-02',
      'south-coast-03',
    ],
    parameters: {
      instantHeat: 'active 300°C',
      optionalConstantTemp: 'ready 150°C',
      snowSensor: 'ready 350°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 250°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-01-22'),
    userName: 'carol smith',
    system: 'ess',
    switches: {
      'bet-east': ['01', '03', '04', '05'],
      'bet-west': ['04', '05'],
      'south-coast': ['01', '02', '04', '05'],
    },
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-01',
      'bet-east-03',
      'bet-east-04',
      'bet-east-05',
      'bet-west-04',
      'bet-west-05',
      'south-coast-01',
      'south-coast-02',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 300°C',
      optionalConstantTemp: 'ready 150°C',
      snowSensor: 'ready 350°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 250°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-02-11'),
    userName: 'carol smith',
    system: 'ess',
    switches: '15',
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-05',
      'bet-west-01',
      'bet-west-02',
      'bet-west-05',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 375°C',
      optionalConstantTemp: 'ready 100°C',
      snowSensor: 'ready 450°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 350°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-02-04'),
    userName: 'carol smith',
    system: 'ess',
    switches: '15',
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-05',
      'bet-west-01',
      'bet-west-02',
      'bet-west-05',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 375°C',
      optionalConstantTemp: 'ready 100°C',
      snowSensor: 'ready 450°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 350°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-02-10'),
    userName: 'carol smith',
    system: 'ess',
    switches: '15',
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-05',
      'bet-west-01',
      'bet-west-02',
      'bet-west-05',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 375°C',
      optionalConstantTemp: 'ready 100°C',
      snowSensor: 'ready 450°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 350°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-01-02'),
    userName: 'carol smith',
    system: 'ess',
    locations: ['bet-east', 'bet-west', 'south-coast'],
    switches: {
      'bet-east': ['05'],
      'bet-west': ['02', '05'],
      'south-coast': ['04', '05'],
    },
    machines: [
      'bet-east-05',
      'bet-west-01',
      'bet-west-02',
      'bet-west-05',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 375°C',
      optionalConstantTemp: 'ready 100°C',
      snowSensor: 'ready 450°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 350°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-02-02'),
    userName: 'andrew reynold',
    system: 'tgs',
    switches: {
      'bet-east': ['01', '02', '03', '04', '05'],
      'bet-west': ['01', '02', '03', '04', '05'],
      'south-coast': ['01', '02', '03', '04', '05'],
    },
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-01',
      'bet-east-02',
      'bet-east-03',
      'bet-east-04',
      'bet-east-05',
      'bet-west-01',
      'bet-west-02',
      'bet-west-03',
      'bet-west-04',
      'bet-west-05',
      'south-coast-01',
      'south-coast-02',
      'south-coast-03',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 300°C ',
      fanOnly: '',
      snowSensor: '',
      heatingSchedule: '',
      windFactor: '',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-02-02'),
    userName: 'andrew reynold',
    system: 'tes',
    switches: {
      'bet-east': ['01', '02'],
      'bet-west': ['01', '02', '03', '04'],
      'south-coast': ['01', '02', '03'],
    },
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-01',
      'bet-east-02',
      'bet-west-01',
      'bet-west-02',
      'bet-west-03',
      'bet-west-04',
      'south-coast-01',
      'south-coast-02',
      'south-coast-03',
    ],
    parameters: {
      instantHeat: 'active 300°C',
      optionalConstantTemp: 'ready 150°C',
      snowSensor: 'ready 350°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 250°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-02-07'),
    userName: 'andrew reynold',
    system: 'ess',
    switches: {
      'bet-east': ['01', '03', '04', '05'],
      'bet-west': ['04', '05'],
      'south-coast': ['01', '02', '04', '05'],
    },
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-01',
      'bet-east-03',
      'bet-east-04',
      'bet-east-05',
      'bet-west-04',
      'bet-west-05',
      'south-coast-01',
      'south-coast-02',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 300°C',
      optionalConstantTemp: 'ready 150°C',
      snowSensor: 'ready 350°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 250°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-02-12'),
    userName: 'andrew reynold',
    system: 'ess',
    switches: {
      'bet-east': ['05'],
      'bet-west': ['01', '02', '05'],
      'south-coast': ['04', '05'],
    },
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-05',
      'bet-west-01',
      'bet-west-02',
      'bet-west-05',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 375°C',
      optionalConstantTemp: 'ready 100°C',
      snowSensor: 'ready 450°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 350°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-02-16'),
    userName: 'andrew reynold',
    system: 'ess',
    switches: {
      'bet-east': ['05'],
      'bet-west': ['01', '02', '05'],
      'south-coast': ['04', '05'],
    },
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-05',
      'bet-west-01',
      'bet-west-02',
      'bet-west-05',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 375°C',
      optionalConstantTemp: 'ready 100°C',
      snowSensor: 'ready 450°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 350°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-02-22'),
    userName: 'andrew reynold',
    system: 'ess',
    switches: {
      'bet-east': ['05'],
      'bet-west': ['01', '02', '05'],
      'south-coast': ['04', '05'],
    },
    locations: ['bet-east', 'bet-west', 'south-coast'],
    machines: [
      'bet-east-05',
      'bet-west-01',
      'bet-west-02',
      'bet-west-05',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 375°C',
      optionalConstantTemp: 'ready 100°C',
      snowSensor: 'ready 450°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 350°C',
    },
  },
  {
    companyName: 'mca',
    date: new Date('2023-01-14'),
    userName: 'andrew reynold',
    system: 'ess',
    locations: ['bet-east', 'bet-west', 'south-coast'],
    switches: {
      'bet-east': ['05'],
      'bet-west': ['01', '02', '05'],
      'south-coast': ['04', '05'],
    },
    machines: [
      'bet-east-05',
      'bet-west-01',
      'bet-west-02',
      'bet-west-05',
      'south-coast-04',
      'south-coast-05',
    ],
    parameters: {
      instantHeat: 'active 375°C',
      optionalConstantTemp: 'ready 100°C',
      snowSensor: 'ready 450°C',
      heatingSchedule: 'ready 450°C',
      windFactor: 'ready 350°C',
    },
  },
];

export const DUMMY_LOGIN_INFO = [
  { login: new Date('2022-01-14'), logout: new Date('2022-01-15') },
  { login: new Date('2022-02-14'), logout: new Date('2022-02-15') },
  { login: new Date('2022-03-14'), logout: new Date('2022-03-15') },
  { login: new Date('2022-04-14'), logout: new Date('2022-04-15') },
  { login: new Date('2022-05-14'), logout: new Date('2022-04-15') },
  { login: new Date('2023-02-14'), logout: new Date('2023-02-15') },
  { login: new Date('2023-03-14'), logout: new Date('2023-03-15') },
  { login: new Date('2023-04-14'), logout: new Date('2023-04-15') },
  { login: new Date('2023-05-14'), logout: new Date('2023-05-15') },
  { login: new Date('2023-06-14'), logout: new Date('2023-06-15') },
  { login: new Date('2023-07-14'), logout: new Date('2023-07-15') },
  { login: new Date('2023-08-14'), logout: new Date('2023-08-15') },
  { login: new Date('2023-09-14'), logout: new Date('2023-09-15') },
  { login: new Date('2023-10-14'), logout: new Date('2023-10-15') },
  { login: new Date('2023-11-14'), logout: new Date('2023-11-15') },
  { login: new Date('2023-12-14'), logout: new Date('2023-12-15') },
];
